export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "missionCreation": {
            "steps": {
                "motif": "Reason",
                "period": "Period",
                "details": "Details",
                "invitation": "Invitation",
                "confirmation": "Confirmation",
            },
            "wizard": {
                "stepCount": "Step {current} of {total}",
                "back": "Back",
                "next": "Next",
                "create": "Create the mission",
                "creating": "Creating the mission",
                "backToStep": "Go back to this step",
                "leaveLabel": "Leave mission creation",
                "leaveTooltip": "Quit",
                "leaveConfirm": "Are you sure you want to leave this page? Your changes will not be saved.",
            },
            "estimator": {
                "detailTitle": "Estimate details",
                "reducedRate": "Reduced rate on your pool's profiles",
                "ifPrivatePoolAccepts": "If a profile from your pool accepts",
                "ifJobbizAccepts": "If a Jobbiz profile accepts",
                "total": "Estimated total",
            },
            "motif": {
                "title": "Reasons",
                "description": "Select the reason for using temporary work for this mission.",
                "types": {
                    "replacement": "Replacement of one or more absent employees",
                    "activityIncrease": "Temporary increase in activity",
                    "awaitingRecruitment": "Awaiting recruitment",
                    "customaryContract": "Customary temporary contract",
                    "seasonal": "Seasonal employment",
                },
            },
            "motifForm": {
                "description": "Your description",
                "name": "Last name",
                "firstname": "First name",
                "replacedPosition": "Position replaced",
                "absenceDescription": "Describe precisely the reason for your employee's absence.",
                "date": "Date",
                "nameRequired": "Please enter a last name",
                "firstnameRequired": "Please enter a first name",
                "positionRequired": "Please enter a position",
                "nameMissing": "A last name is required",
                "firstnameMissing": "A first name is required",
                "dateMissing": "A date is required",
                "reasonDescriptions": {
                    "temporaryActivity": "To handle a one-off rise in activity: an exceptional order, a temporary workload peak or an occasional task outside your usual activity.",
                    "awaitingRecruitment": "To fill a position until an employee hired on a permanent contract arrives. Give the person hired and their planned start date.",
                    "replacement": "To replace an absent employee or one whose contract is suspended (leave, sick leave, training…). Say who is replaced and why.",
                    "seasonal": "For tasks that come back every year at the same time, with the seasons or consumer habits: tourist season, harvests, end-of-year holidays.",
                    "customaryContract": "For sectors where permanent contracts are customarily not used for these jobs, temporary by nature: hospitality, events, entertainment…",
                },
                "reasonPlaceholders": {
                    "temporaryActivity": "E.g. an exceptional order from a customer, annual stocktaking, opening a new department…",
                    "replacement": "E.g. sick leave until 15 November, maternity leave, paid leave…",
                    "seasonal": "E.g. extra staff for the tourist season, preparing Christmas orders…",
                    "customaryContract": "E.g. extra waiter for a wedding, catering at a seminar…",
                },
            },
            "scheduleForm": {
                "selectedDay": "Selected day",
                "startTime": "Start time",
                "endTime": "End time",
                "repeatUntilEnd": "Repeat until the end of the mission",
                "repeatEndDate": "Ends on",
                "deleteThisDay": "This day",
                "deleteThisDayAndNext": "This day and all following days with the same periods",
                "deleteAllSame": "All days with the same periods",
                "removePeriod": "Remove the period",
            },
            "scheduleList": {
                "deleteWeek": "Delete the week",
                "previousWeek": "Previous week",
                "nextWeek": "Next week",
                "deleteDay": "Delete",
                "deleteDayLabel": "Delete the day",
                "editDay": "Edit",
                "editDayLabel": "Edit the day",
                "addDay": "Add",
                "addDayLabel": "Add a day",
            },
            "modal": {
                "close": "Close",
            },
            "salary": {
                "hourlyRate": "Gross hourly rate",
                "placeholder": "E.g. 12.50",
                "unit": "€/hour",
                "tooltip": "Pay includes the base salary or wage and all other benefits and extras paid directly or indirectly, in cash or in kind.",
            },
            "contact": {
                "name": "Full name of the manager",
                "poste": "Job title",
            },
            "period": {
                "title": "Mission period",
                "description": "Enter the start and end dates of the mission.",
                "dateStart": "Start date",
                "dateEnd": "End date",
                "datePlaceholder": "Select",
                "invalidDate": "Please enter a valid date",
                "scheduleTitle": "Schedule",
                "scheduleDescription": "Set the working hours for each day of the mission.",
            },
            "details": {
                "title": "Instructions",
                "description": "Specific to this mission, they do not change the job description.",
                "tempWorker": "For the temp worker",
                "tempWorkerPlaceholder": "E.g. The staff entrance is the door to the left of the shop sign",
                "jobbiz": "For the Jobbiz team",
                "jobbizPlaceholder": "E.g. independent profile wanted",
            },
            "invitation": {
                "title": "Work with a profile again?",
                "description": "Select the profiles to place first, among Jobbiz profiles and your pool. Only available profiles are shown.",
                "searchPlaceholder": "First or last name",
                "searchLabel": "Search for a profile",
                "loadError": "An error occurred, please try again later.",
                "tabs": {
                    "label": "Profiles to invite",
                    "jobbiz": "Jobbiz profiles",
                    "privatePool": "Private pool",
                    "selection": "Selection",
                },
                "jobbiz": {
                    "ago": "{duration} ago",
                    "endsIn": "ends in {duration}",
                    "at": "at",
                    "day": "day",
                    "days": "days",
                    "hour": "hour",
                    "hours": "hours",
                    "minutes": "minutes",
                    "seconds": "seconds",
                },
                "groupMissions": {
                    "oneMission": "{count} mission",
                    "manyMissions": "{count} missions",
                    "oneInGroup": "{count} mission in your group",
                    "manyInGroup": "{count} missions in your group",
                    "lastMission": "Last mission",
                    "today": "today",
                    "ago": "{duration} ago",
                    "oneDay": "{count} day",
                    "manyDays": "{count} days",
                    "oneMonth": "{count} month",
                    "manyMonths": "{count} months",
                    "oneYear": "{count} year",
                    "manyYears": "{count} years",
                },
                "selection": {
                    "jobbizDetail": "Jobbiz profile · standard rate",
                    "privatePoolDetail": "Your pool · reduced rate",
                    "empty": "No profile selected",
                },
                "backfill": {
                    "label": "Jobbiz fills in if needed",
                    "help": "If a candidate drops out or more people are needed, Jobbiz offers the mission to its profiles, at the standard rate.",
                    "moreInfo": "Learn more",
                },
                "errors": {
                    "selectionRequired": "Select at least one profile or let Jobbiz fill the mission.",
                },
            },
            "confirmation": {
                "title": "All good?",
                "description": "Review the mission before creating it. The job description cannot be changed here.",
                "motif": "Reason",
                "period": "Mission period",
                "invitations": "Invited temp workers",
                "tempWorkerInstructions": "Temp worker instructions",
                "jobbizInstructions": "Jobbiz instructions",
                "template": "Job description",
                "none": "None",
                "noneFeminine": "None",
                "edit": "Edit",
                "editMotif": "Edit the reason",
                "editPeriod": "Edit the period",
                "editInvitations": "Edit the invitations",
                "editTempWorkerInstructions": "Edit the temp worker instructions",
                "editJobbizInstructions": "Edit the Jobbiz instructions",
                "sourceJobbiz": "Jobbiz profile",
                "sourcePrivatePool": "Your pool",
                "jobbizBackfill": "Jobbiz fills in if needed",
                "editJobbizBackfill": "Edit \u201cJobbiz fills in if needed\u201d",
                "yes": "Yes",
                "no": "No",
            },
        },
        "invoice": {
            "detailTitle": "Invoice no. ",
        },
        "missionTemplate": {
            "tools": {
                "provider": {
                    "company": "Company",
                    "temp_worker": "Temp worker",
                },
                "addLabel": "Add equipment",
                "noOptions": "No equipment available",
                "providerSwitch": {
                    "company": "Switch to “provided by the company”",
                    "temp_worker": "Switch to “brought by the temp worker”",
                },
                "providerVerb": {
                    "temp_worker": "brought by",
                    "company": "provided by",
                },
                "providerWho": {
                    "temp_worker": "the temp worker",
                    "company": "the company",
                },
                "providerSelectLabel": "Provider",
                "removeLabel": "Remove",
            },
            "pageTitle": {
                "create": "New job template",
                "edit": "Edit job template",
            },
            "steps": {
                "activity": "Business sector",
                "riskyPosition": "High-risk position",
                "prerequis": "Prerequisites",
                "tasks": "Tasks",
                "locationSalary": "Location & pay",
                "confirmation": "Confirmation",
            },
            "wizard": {
                "stepCount": "Step {current} of {total}",
                "back": "Back",
                "next": "Next",
                "save": "Save the template",
                "saving": "Saving…",
                "backToStep": "Back to this step",
                "leaveLabel": "Leave the job template creation",
                "leaveTooltip": "Quit",
                "leaveTitle": "Leave the job template creation",
                "leaveCancel": "Cancel",
                "leaveSubmit": "Confirm",
                "leaveConfirm": "Are you sure you want to leave this page? Your changes will not be saved.",
                "notFound": "Job template not found",
                "activityRequired": "Please select a sector and a qualification",
                "nameRequired": "Please enter the job template title",
                "nameTaken": "A job template already has this name",
                "tasksRequired": "Please keep at least one task",
                "locationRequired": "Please enter an address",
                "salaryRequired": "Please enter an hourly rate",
                "contactRequired": "Please fill in the on-site manager details",
                "created": "Job template created",
                "updated": "Job template updated",
                "createFailed": "Could not create the template",
                "updateFailed": "Could not update the template",
            },
            "activity": {
                "sectorTitle": "Business sector",
                "sectorDescription": "Which sector is the position in?",
                "qualificationTitle": "Qualification",
                "qualificationDescription": "What job does the temp worker do?",
                "qualificationPlaceholder": "Choose a qualification",
                "qualificationNoOptions": "Select the business sector",
                "nameTitle": "Job template title",
                "nameDescription": "It starts with the qualification. Complete it after the dash (e.g. Night, Fresh aisle).",
                "namePlaceholder": "E.g. Order picker - Night",
                "nameSuffixPlaceholder": "E.g. Night",
                "nameTaken": "A job template already has this name.",
            },
            "riskyPosition": {
                "title": "High-risk position",
                "description": "Some positions require reinforced safety training.",
                "question": "Is this a high-risk position?",
                "articleLink": "See article L. 4161-1 of the French Labour Code",
                "listLabel": "High-risk positions concerned",
                "empty": "No high-risk position available",
                "loadError": "Could not load the list of high-risk positions. Please try again later.",
                "selectionRequired": "Please select at least one high-risk position",
                "summaryNo": "No",
                "summaryYes": "Yes",
            },
            "prerequis": {
                "title": "Prerequisites",
                "description": "List the qualifications and equipment essential for these missions.",
                "tools": "Equipment",
                "toolsPlaceholder": "Add equipment",
                "licences": "Licences",
                "licencesPlaceholder": "Add a licence",
                "languages": "Languages",
                "languagesPlaceholder": "Add a language",
                "dressCode": "Dress code",
                "dressCodePlaceholder": "E.g. black polo shirt and black trousers (coloured clothes not accepted)",
                "dressCodeTooltip": "Clothing style expected during the assignment",
            },
            "tasks": {
                "title": "Job tasks",
                "description": "Tick the suggested tasks or add your own.",
                "addPlaceholder": "Add a task (e.g. receiving deliveries)",
                "addButton": "Add",
                "addedByYou": "Added by you",
                "removeLabel": "Remove",
                "emptyTitle": "No tasks yet",
                "selectAtLeastOne": "Tick at least one task to continue.",
                "noProposal": "No task is suggested for this qualification. Use the field above to add the ones the temp worker will do.",
                "duplicate": "This task is already in the list.",
                "tooMany": "The maximum number of tasks has been reached.",
                "checking": "Checking",
                "rejected": "“{label}” does not describe a job task.",
                "savingChecks": "Checking tasks…",
                "existingTicked": "“{match}” already exists: it has been ticked.",
                "existingListed": "“{match}” is already in the list.",
                "addAsNew": "Add as a new task",
                "closeLabel": "Close",
                "uncheckedTooLong": "“{label}” could not be checked: add the tasks one at a time (80 characters at most).",
            },
            "locationSalary": {
                "locationTitle": "Workplace",
                "locationDescription": "Where should the temp worker report?",
                "addressLabel": "Address",
                "addressSearchLabel": "Search for a place",
                "salaryTitle": "Pay",
                "salaryDescription": "Gross hourly rate, excluding bonuses and premiums.",
                "salaryPlaceholder": "E.g. 12.50",
                "salaryUnit": "€/h",
                "indexedTooltip": "When the template is indexed to the minimum wage, the rate automatically follows the latest official value.",
                "indexedLabel": "Index to the minimum wage ({smic})",
                "belowMinimumWage": "The rate must be at least the minimum wage ({smic} €/h).",
                "contactTitle": "On-site manager",
                "contactDescription": "The person the temp worker will contact on arrival.",
                "contactName": "Full name",
                "contactPoste": "Position",
                "contactPosteDefault": "Manager",
            },
            "confirmation": {
                "edit": "Edit",
                "title": "All good?",
                "description": "Review the template before saving it. You can edit it later.",
            },
            "summary": {
                "none": "None",
                "noneFeminine": "None",
                "dressCodeMissing": "Not provided",
                "tasksTwo": "{first} and {second}",
                "tasksManyOne": "{first}, {second} and {count} other",
                "tasksMany": "{first}, {second} and {count} others",
                "indexedToMinimumWage": "indexed to the minimum wage",
            },
            "list": {
                "newBadge": "New",
                "banner": {
                    "eyebrow": "New",
                    "title": "Create your assignments in a few clicks",
                    "description": "A job template describes a position once and for all. Your assignments then start from the template.",
                    "benefitTasks": "Tasks and requirements already filled in",
                    "benefitDressCode": "Dress code and equipment known to the temp worker",
                    "benefitTime": "Less typing for every new assignment",
                    "close": "Close",
                },
                "searchPlaceholder": "Search a job template",
                "searchLabel": "Search a job template",
                "create": "Job template",
                "loading": "Loading job templates…",
                "noResult": "No job template matches your search.",
                "perHour": "/h",
                "createRow": "Create a job template",
                "sectionTitle": "Your job templates",
                "sectionHint": "Set up a template once, reuse it for every assignment",
                "grossHourlyRate": "Gross hourly rate",
                "indexedToMinimumWage": "Indexed to the minimum wage",
                "updateTemplate": "Update the template",
                "noQualification": "No qualification",
                "collapseGroup": "Collapse the group",
                "expandGroup": "Expand the group",
            },
            "preview": {
                "defaultTitle": "Job template",
                "closeLabel": "Close the preview",
                "closeTooltip": "Close",
                "edit": "Edit",
                "delete": "Delete",
                "duplicate": "Duplicate",
                "createMission": "Create a mission",
                "belowMinimumWage": "Hourly rate below the minimum wage: edit the template to use it.",
                "belowMinimumWageToast": "This template is below the minimum wage, update it before using it.",
                "fields": {
                    "name": "Title",
                    "activity": "Sector",
                    "qualification": "Qualification",
                    "riskyPosition": "High-risk position",
                    "tools": "Equipment",
                    "licences": "Licences",
                    "languages": "Language",
                    "dressCode": "Dress code",
                    "address": "Address",
                    "salary": "Gross hourly rate",
                    "contact": "Manager",
                    "tasks": "Tasks",
                },
            },
            "duplicate": {
                "title": "Duplicate the job description",
                "description": "The copy keeps all the content of the job description. Give it a name.",
                "nameLabel": "Name of the new job description",
                "suffixPlaceholder": "Suffix",
                "done": "Job description duplicated",
                "failed": "Duplication failed",
            },
            "modal": {
                "close": "Close",
            },
        },
        "missionCreated": {
            "navTitle": "Assignment created",
            "eyebrow": "Congratulations!",
            "title": "Assignment no. {number} published",
            "titleNoNumber": "Your assignment is published",
            "firstMission": "Your first assignment with Jobbiz, welcome aboard!",
            "nthMission": "Assignment no. {rank} with Jobbiz.",
            "description": "Temp workers can see it right now. We will let you know as soon as a profile is assigned.",
            "descriptionInvitedOnly": "It is offered only to the profiles you invited. We will let you know as soon as a profile is assigned.",
            "recapTitle": "Summary",
            "nextTitle": "What's next?",
            "period": "Period",
            "place": "Workplace",
            "wage": "Hourly rate",
            "seeMission": "See the assignment",
            "copyLink": "Copy the link",
            "linkCopied": "Assignment link copied",
            "linkCopyError": "The link could not be copied",
            "createAnother": "Create another assignment",
            "loadError": "The assignment could not be loaded",
            "previewButton": "Test the \"Assignment created\" screen",
            "previewEmpty": "No assignment to show",
        },
        "missionFiche": {
            "tasksTitle": "Tasks of the {title}",
            "tasksTitleElided": "Tasks of the {title}",
            'missionNumber': 'Assignment #{number}',
            'status': {
                'inProgress': 'In progress',
                'upcoming': 'Upcoming',
                'finished': 'Finished',
            },
            'noLocation': 'Location not specified',
            'description': 'Description',
            'seeMore': 'See more',
            'seeLess': 'See less',
            'period': 'Period',
            'periodRange': 'From {start} to {end}',
            'periodDay': 'On {date}',
            'noDates': 'Dates not specified',
            'hourlyWage': 'Gross hourly wage',
            'hourlyWageValue': '€{amount}/h',
            'wageUnknown': 'Depending on experience',
            'contact': 'Manager',
            'notProvided': 'Not provided',
            'tempWorker': 'Temp worker',
            'noTempWorker': 'No temp worker assigned',
            'planning': {
                'title': 'Schedule',
                'notWorked': 'Day off',
                'previous': 'Previous week',
                'next': 'Next week',
            },
            'reason': {
                'title': 'Reason for recruitment',
                'temporaryActivity': 'Temporary increase in activity',
                'awaitingRecruitment': 'Awaiting recruitment',
                'replacement': 'Replacement of an absent employee',
                'temporaryContract': 'Customary temporary contract',
                'seasonal': 'Seasonal employment',
                'noDetail': 'No details provided',
                'person': 'Person: {value}',
                'plannedDate': 'Planned date: {value}',
                'replacedEmployee': 'Replaced employee: {value}',
                'position': 'Position: {value}',
                'motive': 'Reason: {value}',
            },
            'requirements': {
                'tools': 'Equipment',
                'licences': 'Licences',
                'language': 'Languages',
                'required': 'Required for this assignment',
                'toolProvidedBy': {
                    'company': 'Provided by the company',
                    'temp_worker': 'Brought by the temp worker',
                },
            },
            'dressCode': 'Dress code',
            'recruitment': {
                'published': 'Assignment published',
                'publishedOn': 'On {date}',
                'recruiting': 'Recruitment in progress',
                'searching': 'We are looking for a profile for this assignment.',
                'pendingOne': '{count} application being processed',
                'pendingMany': '{count} applications being processed',
                'assigned': 'Temp worker assigned',
                'assignedHint': 'Their name will appear on this sheet.',
            },
            'workplace': 'Workplace',
            'copyLink': 'Copy the assignment link',
            'linkCopied': 'Assignment link copied',
            'linkCopyError': 'The link could not be copied',
            'openMaps': 'Open in Google Maps',
            'createdAt': 'Assignment #{number} created on {date}',
        },
        "select": {
            "placeholder": "Select…",
            "noOptions": "No results",
            "remove": "Remove",
        },
        "appPro": {
            "navButton": "Download the pro app",
            "eyebrow": "Mobile app",
            "title": "Jobbiz Pro, your assignments in your pocket",
            "description": "The essentials of your company space, on your phone, wherever you are.",
            "benefitMissions": "Create and follow your assignments",
            "benefitTimesheets": "Approve timesheets in a few seconds",
            "benefitContracts": "Sign your contracts without a computer",
            "qrAlt": "QR code to download the Jobbiz Pro app",
            "qrHint": "Scan with your phone's camera",
            "or": "or",
            "appStore": "App Store",
            "googlePlay": "Google Play",
            "close": "Close",
        },
        "intercom": {
            "launcherTooltip": "Need help?",
        },
        "field": {
            "lengthHint": "{min} min / {max} characters",
            "lengthCount": "{count} / {max} characters",
        },
        "perimeters": {
            "tab": "Perimeters",
            "title": "Perimeters",
            "description": "Define what your managers can access to manage missions, contract signatures and timesheets",
            "roles": {
                "200": "Observer",
                "205": "Manager",
                "210": "Supervisor",
                "215": "Director",
                "220": "Coordinator",
                "225": "Administrator",
            },
            "list": {
                "loading": "Loading perimeters…",
                "loadError": "Could not load the perimeters.",
                "forbidden": "You do not have the rights required to manage perimeters.",
                "retry": "Retry",
                "create": "Create",
                "edit": "Edit",
                "archive": "Archive",
                "members": {
                    "one": "{count} member",
                    "many": "{count} members",
                },
                "noMembers": "No member attached",
            },
            "empty": {
                "title": "No perimeter yet",
                "description": "Without a perimeter, all your managers see every mission, contract and timesheet. Create perimeters (a department, a site, a team...) to limit their access.",
            },
            "form": {
                "createTitle": "Create a perimeter",
                "createDescription": "Attach the members who will manage the missions of this perimeter. Members without a perimeter still see everything.",
                "nameLabel": "Perimeter name",
                "namePlaceholder": "E.g. Kitchen, Lamentin site, Night team",
                "membersLabel": "Attached members (optional)",
                "searchPlaceholder": "Search a member",
                "noAssignableMember": "No member to attach for now.",
                "noSearchResult": "No member matches your search.",
                "create": "Create",
                "creating": "Creating…",
                "editTitle": "Edit “{name}”",
                "editDescription": "Changes apply right away to the members' access.",
                "save": "Save",
                "saving": "Saving…",
            },
            "modal": {
                "cancel": "Cancel",
            },
            "delete": {
                "title": "Delete “{name}”?",
                "description": "This perimeter is not attached to any mission. It will be permanently deleted.",
                "confirm": "Delete",
                "deleting": "Deleting…",
            },
            "archive": {
                "title": "Archive “{name}”?",
                "transferTitle": "Archive “{name}”",
                "finishedMissions": {
                    "one": "The finished mission keeps this perimeter in its history.",
                    "many": "The {count} finished missions keep this perimeter in their history.",
                },
                "notProposed": "It will no longer be offered for new missions and you can restore it at any time.",
                "activeMissions": {
                    "one": "{count} ongoing or upcoming mission",
                    "many": "{count} ongoing or upcoming missions",
                },
                "transferIntro": "{missions} and {members} are attached to this perimeter. Finished missions keep it in their history.",
                "transferLabel": "Transfer the missions and the members to",
                "noPerimeter": "No perimeter",
                "confirm": "Archive",
                "archiving": "Archiving…",
                "usageError": "Could not check the access of the members concerned.",
            },
            "restore": {
                "title": "Restore “{name}”?",
                "description": {
                    "one": "This perimeter comes back without members. Its finished mission will be restricted to it again: until you attach members, only administrators, directors and members without a perimeter will see it.",
                    "many": "This perimeter comes back without members. Its {count} finished missions will be restricted to it again: until you attach members, only administrators, directors and members without a perimeter will see them.",
                },
                "restoring": "Restoring…",
            },
            "alert": {
                "membersAccess": {
                    "one": "The member concerned will have access to every mission, contract and timesheet.",
                    "many": "The {count} members concerned will have access to every mission, contract and timesheet.",
                },
            },
            "archived": {
                "heading": "Archived ({count})",
                "archivedOn": "Archived on {date}",
                "finishedMissions": {
                    "one": "{count} finished mission",
                    "many": "{count} finished missions",
                },
                "restore": "Restore",
                "loadError": "Could not load the archived perimeters.",
            },
            "toast": {
                "created": "Perimeter created",
                "updated": "Perimeter updated",
                "archived": "Perimeter archived",
                "deleted": "Perimeter deleted",
                "transferred": {
                    "one": "{count} mission transferred to {name}",
                    "many": "{count} missions transferred to {name}",
                },
                "archivedNoPerimeter": {
                    "one": "Perimeter “{name}” archived · {count} mission has no perimeter anymore",
                    "many": "Perimeter “{name}” archived · {count} missions have no perimeter anymore",
                },
                "restored": "Perimeter “{name}” restored",
            },
            "errors": {
                "generic": "Something went wrong. Please try again.",
                "nameRequired": "The perimeter name is required.",
                "nameTooLong": "This name is too long.",
                "nameTaken": "A perimeter already has this name (active or archived).",
                "memberInvalid": "This member is no longer available: the list has been refreshed.",
                "notFound": "This perimeter no longer exists.",
                "archived": "This perimeter is archived: restore it before editing it.",
                "alreadyArchived": "This perimeter is already archived.",
                "notArchived": "This perimeter is no longer archived.",
                "inUse": "This perimeter has already been attached to a mission: it can no longer be deleted, only archived.",
                "transferInvalid": "The chosen perimeter is no longer available for the transfer.",
            },
            "missionStep": {
                "step": "Details",
                "title": "Perimeter",
                "placeholder": "Select",
                "noPerimeter": "No perimeter",
                "noPerimeterHint": "Visible to all managers",
                "help": "Only the managers of this perimeter will see the mission, its contracts and its timesheets. Without a perimeter, it is visible to everyone.",
                "restrictedHelp": "You can only attach a mission to your perimeters: {names}.",
                "next": "Next",
                "errors": {
                    "required": "Choose a perimeter for this mission.",
                    "forbidden": "You cannot attach the mission to this perimeter. Choose another one.",
                    "archived": "This perimeter has just been archived. Choose another one.",
                    "notFound": "This perimeter no longer exists. Choose another one.",
                },
            },
            "missionDetail": {
                "label": "Perimeter",
                "none": "None",
                "archived": "(archived)",
                "edit": "Edit",
            },
            "listFilter": {
                "button": "Perimeter",
                "count": "{count} perimeters",
                "noPerimeter": "No perimeter",
                "noPerimeterHint": "Visible to all managers",
                "clear": "Clear",
                "column": "Perimeter",
                "errors": {
                    "invalid": "This perimeter filter is not valid: it has been cleared.",
                    "forbidden": "You no longer have access to one of these perimeters: the filter has been cleared.",
                    "notFound": "One of these perimeters no longer exists: the filter has been cleared.",
                },
            },
            "changeMission": {
                "title": "Change the perimeter",
                "recap": "{title} – no. {number}, {status}.",
                "recapWithoutNumber": "{title}, {status}.",
                "appliesNow": "The change applies immediately.",
                "status": {
                    "inProgress": "in progress",
                    "upcoming": "upcoming",
                    "finished": "finished",
                },
                "label": "New perimeter",
                "confirm": "Change",
                "changing": "Changing…",
                "and": " and ",
                "losingAccess": {
                    "one": "{names} will no longer have access to this mission, its contracts and its timesheets.",
                    "many": "{names} will no longer have access to this mission, its contracts and its timesheets.",
                },
                "optionsError": "Could not load the perimeters.",
                "previewError": "Could not check the access of the managers concerned.",
                "errors": {
                    "missionFinished": "This mission is finished: its perimeter can no longer be changed.",
                    "archived": "This perimeter has just been archived. Choose another one.",
                    "notFound": "This perimeter no longer exists. Choose another one.",
                    "forbidden": "You cannot attach the mission to this perimeter. Choose another one.",
                    "missionAccessDenied": "You no longer have access to this mission.",
                },
            },
        },
        "missionAccess": {
            "back": "Back",
            "mission": {
                "title": "You don't have access to this mission",
                "description": "It is not in your perimeter. Please contact your administrator.",
            },
            "document": {
                "title": "You don't have access to this document",
                "description": "This contract or timesheet belongs to a mission or a company you don't have access to. Please contact your administrator.",
            },
        },
        "accountStatement": {
            "openButton": "Account statement (PDF)",
            "title": "Account statement",
            "description": "Choose the period of the account statement to download.",
            "from": "From",
            "to": "To",
            "cancel": "Cancel",
            "download": "Download",
            "downloading": "Downloading…",
            "missingDate": "Enter a start date and an end date.",
            "invertedPeriod": "The start date must be before the end date.",
            "errors": {
                "customerNotLinked": "This company is not linked to a Pennylane customer.",
                "pennylaneUnavailable": "Pennylane is not responding, please try again in a few minutes.",
                "pennylaneReadsDisabled": "Reading from Pennylane is disabled on this environment.",
                "tooLarge": "This account has too many entries to generate the statement. Contact Jobbiz to get it.",
                "invalidPeriod": "The period is invalid.",
                "forbidden": "You don't have access to the account statement.",
                "failed": "The statement could not be generated.",
            },
        },
        "contract": {
            "documentUnavailable": "The contract document is not available yet. Please try again later or contact your agency.",
        },
        "switchCompany": {
            "error": "Switching company failed. Please try again.",
        },
        "privatePool": {
            "searchPlaceholder": "Name, phone or email",
            "add": "Add",
            "noResult": "No results",
            "loadError": "The private pool could not be loaded, please try again later.",
            "firstLoadError": "The private pool could not be loaded.",
            "retry": "Try again",
            "member": {
                "addedOn": "added on {date}",
                "oneMission": "1 mission with you",
                "manyMissions": "{count} missions with you",
                "pending": "Sign-up in progress",
            },
            "intro": {
                "badge": "New",
                "title": "Recruit your own candidates",
                "description": "Add the people you already know. Jobbiz hires them as temp workers for you.",
                "benefitContracts": "Contracts and payroll handled by Jobbiz",
                "benefitRate": "A reduced rate on these profiles",
                "close": "Close",
            },
            "empty": {
                "title": "Your private pool is empty",
                "description": "Add a candidate with their name and phone or email to invite them to your missions.",
                "addCandidate": "Add a candidate",
            },
            "addModal": {
                "title": "Add to private pool",
                "description": "They can be invited to your missions. Jobbiz hires them as a temp worker for you, at a reduced rate.",
                "close": "Close",
                "firstname": "First name",
                "lastname": "Last name",
                "contact": "Phone or email",
                "contactHint": "We send them a text message or an e-mail to join your pool.",
                "or": "or",
                "selfSignupTitle": "Let them sign up on their own",
                "selfSignupDescription": "Share the link or show the QR code: they join your pool by filling in a short form.",
                "copyLink": "Copy link",
                "downloadQrCode": "QR code",
                "qrCodeAlt": "QR code of the invite link",
                "linkCopied": "Link copied",
                "linkCopyError": "The link could not be copied",
                "qrCodeError": "The QR code could not be generated",
                "cancel": "Cancel",
                "submit": "Add",
                "alreadyInPool": "This candidate is already in your pool.",
                "invalidInput": "Check the first name, the last name and the phone or email.",
                "placedInGroupTitle": "{name} has already worked with your group",
                "placedInGroupDescription": "Jobbiz has already placed them in your group, so they cannot join the private pool. You can invite them to this mission.",
                "inviteOnMission": "Invite them to this mission",
                "error": "The candidate could not be added, please try again later.",
            },
        },
        map : new Map()
    }
}